export class ParticlesInteractorBase {
    constructor(container) {
        this.container = container;
        this.type = 1;
    }
}
